module.exports = __webpack_public_path__ + "img/_MG_4649-greeninger-cropped-compressed-large.baa605a3.webp";